export const CONFIG_DEFAULT = {
    theme: "web",
    assetPath: "./themes/",
    logLevel: "warn",
    setLogLevel: (level) => {
        if (window.trumpf) {
            window.trumpf.ux.logLevel = level;
        }
    }
};
//# sourceMappingURL=defaults.js.map
